export default {
	"Group.remainder": "剩余",
	"Group.TheyAreInAGroupAndCanBeDirectlyInvolved": "他们正在拼团，可直接参与",
	"Group.NotBad": "还差",
	"Group.PeopleInGroups": "人成团",
	"Group.GoOnATour": "去参团"
}